import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Card,
  CardContent,
  MenuItem,
  Snackbar,
  Alert
} from '@mui/material';

class LeadCapturePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        nome: '',
        whatsapp: '',
        nomeNegocio: '',
        tipoNegocio: '',
        pedidosDia: ''
      },
      loading: false,
      feedback: {
        open: false,
        severity: 'success',
        message: ''
      }
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    fetch('/api/leads', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.formData)
    })
      .then((res) => {
        if (!res.ok) throw new Error('Erro ao enviar os dados');
        return res.json();
      })
      .then(() => {
        this.setState({
          feedback: {
            open: true,
            severity: 'success',
            message: 'Demonstração agendada com sucesso! Entraremos em contato em breve.'
          },
          formData: {
            nome: '',
            whatsapp: '',
            nomeNegocio: '',
            tipoNegocio: '',
            pedidosDia: ''
          }
        });
      })
      .catch((err) => {
        this.setState({
          feedback: {
            open: true,
            severity: 'error',
            message: 'Falha ao agendar. Tente novamente em instantes.'
          }
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleCloseSnackbar = () => {
    this.setState((prevState) => ({
      feedback: {
        ...prevState.feedback,
        open: false
      }
    }));
  };

  render() {
    const { formData, loading, feedback } = this.state;

    return (
      <Box sx={{ bgcolor: '#F8F9FA', minHeight: '100vh', py: { xs: 4, md: 8 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">

            {/* Lado Esquerdo - Chamada Principal e Benefícios */}
            <Grid item xs={12} md={6}>
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: '#6C5CE7',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: 1.2,
                    mb: 1
                  }}
                >
                  Demonstração Exclusiva
                </Typography>
                <Typography
                  variant="h3"
                  component="h1"
                  sx={{
                    fontWeight: 800,
                    color: '#2D3436',
                    fontSize: { xs: '2rem', md: '2.75rem' },
                    lineHeight: 1.2,
                    mb: 2
                  }}
                >
                  Veja como o FazPedido transforma a gestão do seu negócio
                </Typography>
                <Typography variant="body1" sx={{ color: '#636E72', fontSize: '1.1rem', mb: 4 }}>
                  Agende uma apresentação individual e descubra como integrar seu catálogo, PDV e delivery em uma só plataforma.
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Card elevation={0} sx={{ border: '1px solid #E4E7EB', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#2D3436' }}>
                        ⚡ Apresentação personalizada
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#636E72' }}>
                        Focada na rotina do seu estabelecimento e nos seus gargalos de atendimento.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card elevation={0} sx={{ border: '1px solid #E4E7EB', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#2D3436' }}>
                        📊 Diagnóstico de Operação
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#636E72' }}>
                        Entenda como reduzir custos com taxas e automatizar o controle de estoque.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            {/* Lado Direito - Formulário de Captura */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={4}
                sx={{
                  p: { xs: 3, md: 4 },
                  borderRadius: 3,
                  bgcolor: '#FFFFFF',
                  boxShadow: '0px 10px 30px rgba(108, 92, 231, 0.1)'
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 700, color: '#2D3436', mb: 1 }}>
                  Agendar Demonstração Grátis
                </Typography>
                <Typography variant="body2" sx={{ color: '#636E72', mb: 3 }}>
                  Preencha os dados abaixo. Leva menos de 1 minuto.
                </Typography>

                <Box component="form" onSubmit={this.handleSubmit}>
                  <TextField
                    fullWidth
                    label="Seu Nome Completo"
                    name="nome"
                    value={formData.nome}
                    onChange={this.handleChange}
                    required
                    margin="normal"
                    variant="outlined"
                  />

                  <TextField
                    fullWidth
                    label="WhatsApp com DDD"
                    name="whatsapp"
                    placeholder="(00) 90000-0000"
                    value={formData.whatsapp}
                    onChange={this.handleChange}
                    required
                    margin="normal"
                    variant="outlined"
                  />

                  <TextField
                    fullWidth
                    label="Nome do Negócio"
                    name="nomeNegocio"
                    value={formData.nomeNegocio}
                    onChange={this.handleChange}
                    required
                    margin="normal"
                    variant="outlined"
                  />

                  <TextField
                    fullWidth
                    select
                    label="Tipo de Estabelecimento"
                    name="tipoNegocio"
                    value={formData.tipoNegocio}
                    onChange={this.handleChange}
                    required
                    margin="normal"
                    variant="outlined"
                  >
                    <MenuItem value="restaurante">Restaurante / Lanchonete</MenuItem>
                    <MenuItem value="pizzaria">Pizzaria</MenuItem>
                    <MenuItem value="hamburgueria">Hamburgueria</MenuItem>
                    <MenuItem value="acai_sorvetes">Açaí / Sorveteria</MenuItem>
                    <MenuItem value="marmitaria">Marmitaria</MenuItem>
                    <MenuItem value="outro">Outro</MenuItem>
                  </TextField>

                  <TextField
                    fullWidth
                    select
                    label="Média de Pedidos por Dia"
                    name="pedidosDia"
                    value={formData.pedidosDia}
                    onChange={this.handleChange}
                    required
                    margin="normal"
                    variant="outlined"
                  >
                    <MenuItem value="ate_30">Até 30 pedidos/dia</MenuItem>
                    <MenuItem value="30_a_100">De 30 a 100 pedidos/dia</MenuItem>
                    <MenuItem value="mais_100">Mais de 100 pedidos/dia</MenuItem>
                  </TextField>

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                    sx={{
                      mt: 3,
                      mb: 1,
                      py: 1.5,
                      bgcolor: '#6C5CE7',
                      fontSize: '1rem',
                      fontWeight: 700,
                      borderRadius: 2,
                      textTransform: 'none',
                      '&:hover': {
                        bgcolor: '#5B4BC4'
                      }
                    }}
                  >
                    {loading ? 'Enviando...' : 'Garantir Minha Demonstração'}
                  </Button>

                  <Typography
                    variant="caption"
                    display="block"
                    align="center"
                    sx={{ color: '#B2BEC3', mt: 1 }}
                  >
                    Seus dados estão seguros. Sem compromisso financeiro.
                  </Typography>
                </Box>
              </Paper>
            </Grid>

          </Grid>
        </Container>

        <Snackbar
          open={feedback.open}
          autoHideDuration={6000}
          onClose={this.handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            onClose={this.handleCloseSnackbar}
            severity={feedback.severity}
            sx={{ width: '100%' }}
          >
            {feedback.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default LeadCapturePage;